export enum Position {
  Left = 'left',
  Top = 'top',
  Right = 'right',
  Bottom = 'bottom',
}
export enum EEdgyType {
  Dagre = 'dagre',
  Bezier = 'bezier',
  Straight = 'straight',
  Step = 'step',
  SmoothStep = 'smoothstep',
  SimpleBezier = 'simplebezier',
}
export enum EdgePointerType {
  Circle = 'circle',
  Rect = 'rect',
  Arrow = 'arrow',

}
export enum ELayoutAlgorithms {
  Darge = 'dagre',
  ELK = 'ELK',
  Local = 'local'
}